module.exports = __webpack_public_path__ + "aab4cfbfcb75f19f5a075362f0f8ba14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/puffy-jacket-pink-s.png
// module id = 1981
// module chunks = 0